import React from "react";
import Typography from "../../../components/Typography/Typography";

const EmptyUpcomingLeavesModal = () => {
  return (
    <div className="flex justify-center items-center w-full text-center h-[calc(100vh-264px)]">
      <div>
        <div className="w-[12.875rem] flex justify-center">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="111"
            height="111"
            viewBox="0 0 111 111"
            fill="none"
          >
            <circle cx="55.5" cy="55.5" r="55.5" fill="#F4F4F4" />
            <path
              d="M38.044 25.9141H70.8979C81.4253 25.9141 84.0571 28.5459 84.0571 39.0438V57.7625C84.0571 68.2899 81.4253 70.8922 70.9274 70.8922H38.044C27.5461 70.9218 24.9143 68.2899 24.9143 57.7921V39.0438C24.9143 28.5459 27.5461 25.9141 38.044 25.9141Z"
              fill="white"
              stroke="#EFEFEF"
              stroke-width="3"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M64.109 37.6688V47.6931C64.109 50.7003 62.6053 52.7052 59.0969 52.7052H51.0775C47.569 52.7052 46.0654 50.7003 46.0654 47.6931V37.6688C46.0654 34.6616 47.569 32.6567 51.0775 32.6567H59.0969C62.6053 32.6567 64.109 34.6616 64.109 37.6688Z"
              stroke="#EFEFEF"
              stroke-width="1.5"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M51.0775 37.6685H55.0872"
              stroke="#EFEFEF"
              stroke-width="1.5"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M51.4785 42.6807H58.6959"
              stroke="#EFEFEF"
              stroke-width="1.5"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M51.0775 47.6929H59.0969"
              stroke="#EFEFEF"
              stroke-width="1.5"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M54.4857 70.9219V85.057"
              stroke="#EFEFEF"
              stroke-width="3"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M24.9143 58.4429H84.0571"
              stroke="#EFEFEF"
              stroke-width="3"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M41.1786 85.0576H67.7929"
              stroke="#EFEFEF"
              stroke-width="3"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <circle
              cx="80.7143"
              cy="31.3145"
              r="9.53571"
              fill="white"
              stroke="#EFEFEF"
              stroke-width="1.5"
            />
            <path
              d="M85.2595 34.234C84.9851 33.9619 84.6336 33.781 84.2527 33.716C83.8718 33.651 83.4802 33.7051 83.1312 33.8709L81.6852 32.4312L83.7196 30.403C83.8374 30.2852 83.9037 30.1253 83.9037 29.9586C83.9037 29.7919 83.8374 29.632 83.7196 29.5142C83.6017 29.3963 83.4418 29.3301 83.2751 29.3301C83.1084 29.3301 82.9486 29.3963 82.8307 29.5142L80.8026 31.5486L78.7744 29.5142C78.6565 29.3963 78.4967 29.3301 78.33 29.3301C78.1633 29.3301 78.0034 29.3963 77.8855 29.5142C77.7677 29.632 77.7014 29.7919 77.7014 29.9586C77.7014 30.1253 77.7677 30.2852 77.8855 30.403L79.9199 32.4312L78.4739 33.8772C78.1241 33.7176 77.7345 33.6663 77.3552 33.7299C76.9759 33.7935 76.6244 33.969 76.3457 34.234C76.1611 34.4059 76.0132 34.6132 75.9105 34.8436C75.8079 35.0739 75.7527 35.3226 75.7482 35.5747C75.7438 35.8269 75.7902 36.0774 75.8846 36.3112C75.9791 36.545 76.1197 36.7574 76.298 36.9358C76.4763 37.1141 76.6887 37.2547 76.9226 37.3491C77.1564 37.4436 77.4068 37.4899 77.659 37.4855C77.9111 37.481 78.1598 37.4259 78.3902 37.3232C78.6205 37.2206 78.8278 37.0726 78.9998 36.8881C79.352 36.5362 79.5502 36.0589 79.5506 35.561C79.549 35.2812 79.4848 35.0053 79.3628 34.7535L80.8026 33.3138L82.2423 34.7535C82.1203 35.0053 82.0561 35.2812 82.0545 35.561C82.0542 35.87 82.1302 36.1742 82.2756 36.4468C82.4211 36.7193 82.6315 36.9518 82.8883 37.1236C83.1451 37.2953 83.4403 37.4011 83.7477 37.4315C84.0552 37.4619 84.3654 37.4159 84.6508 37.2977C84.9363 37.1795 85.1881 36.9928 85.3841 36.7539C85.5801 36.5151 85.7141 36.2316 85.7743 35.9286C85.8345 35.6256 85.819 35.3124 85.7292 35.0168C85.6394 34.7212 85.478 34.4523 85.2595 34.234ZM78.1171 36.0055C78.059 36.0641 77.9897 36.1107 77.9134 36.1425C77.8372 36.1743 77.7553 36.1906 77.6727 36.1906C77.5901 36.1906 77.5083 36.1743 77.432 36.1425C77.3557 36.1107 77.2865 36.0641 77.2283 36.0055C77.1412 35.9177 77.0821 35.8062 77.0584 35.6849C77.0347 35.5636 77.0473 35.438 77.0949 35.3239C77.1424 35.2098 77.2226 35.1124 77.3255 35.0438C77.4283 34.9753 77.5491 34.9387 77.6727 34.9387C77.7963 34.9387 77.9171 34.9753 78.0199 35.0438C78.1228 35.1124 78.203 35.2098 78.2505 35.3239C78.2981 35.438 78.3108 35.5636 78.287 35.6849C78.2633 35.8062 78.2042 35.9177 78.1171 36.0055ZM84.3768 36.0055C84.3186 36.0641 84.2494 36.1107 84.1731 36.1425C84.0969 36.1743 84.015 36.1906 83.9324 36.1906C83.8498 36.1906 83.7679 36.1743 83.6917 36.1425C83.6154 36.1107 83.5462 36.0641 83.488 36.0055C83.4293 35.9473 83.3827 35.878 83.3509 35.8018C83.3192 35.7255 83.3028 35.6437 83.3028 35.561C83.3028 35.4784 83.3192 35.3966 83.3509 35.3203C83.3827 35.244 83.4293 35.1748 83.488 35.1166C83.5462 35.0579 83.6154 35.0114 83.6917 34.9796C83.7679 34.9478 83.8498 34.9314 83.9324 34.9314C84.015 34.9314 84.0969 34.9478 84.1731 34.9796C84.2494 35.0114 84.3186 35.0579 84.3768 35.1166C84.4355 35.1748 84.4821 35.244 84.5139 35.3203C84.5456 35.3966 84.562 35.4784 84.562 35.561C84.562 35.6437 84.5456 35.7255 84.5139 35.8018C84.4821 35.878 84.4355 35.9473 84.3768 36.0055Z"
              fill="#EFEFEF"
            />
            <path
              d="M86.4363 26.1719H75.1688C75.0028 26.1719 74.8436 26.2378 74.7262 26.3552C74.6088 26.4726 74.5429 26.6318 74.5429 26.7978V33.0575C74.5429 33.2236 74.6088 33.3828 74.7262 33.5002C74.8436 33.6176 75.0028 33.6835 75.1688 33.6835C75.3348 33.6835 75.4941 33.6176 75.6115 33.5002C75.7288 33.3828 75.7948 33.2236 75.7948 33.0575V27.4238H85.8103V33.0575C85.8103 33.2236 85.8763 33.3828 85.9936 33.5002C86.111 33.6176 86.2703 33.6835 86.4363 33.6835C86.6023 33.6835 86.7615 33.6176 86.8789 33.5002C86.9963 33.3828 87.0622 33.2236 87.0622 33.0575V26.7978C87.0622 26.6318 86.9963 26.4726 86.8789 26.3552C86.7615 26.2378 86.6023 26.1719 86.4363 26.1719Z"
              fill="#EFEFEF"
            />
          </svg>
        </div>
        <Typography
          className="text-gray-700 font-normal mt-2.5"
          size="lg"
          variant="p"
        >
          {/* Your team’s time calendar will<br></br> be represented here. */}
          All of your team time off data will <br />
          be shown here
        </Typography>
      </div>
    </div>
  );
};

export default EmptyUpcomingLeavesModal;
